// extracted by mini-css-extract-plugin
export var image = "t_g";
export var link = "t_bx";
export var logo = "t_br";
export var scrolled = "t_z";